import PropTypes from 'prop-types';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import { MENU_LIST } from '../../../../redux/slices/FJSliceVideoBgRemover';
import FJVideoRemoveBgCustomLeftContainer from '../container/FJVideoRemoveBgCustomLeftContainer';
import FJVideoRemoveBgAutoLeftContainer from '../container/FJVideoRemoveBgAutoLeftContainer';

const FJVideoRemoveBgLeft = ({ curMenuIndex, switchCurMenuIndex }) => {
    return (
        <FJAppLeft>
            <FJMenuTab list={MENU_LIST} curIndex={curMenuIndex} onChange={switchCurMenuIndex} />

            <FJVideoRemoveBgAutoLeftContainer isShow={curMenuIndex === 0} />

            <FJVideoRemoveBgCustomLeftContainer isShow={curMenuIndex === 1} />
        </FJAppLeft>
    );
};

FJVideoRemoveBgLeft.propTypes = {
    uploadVideo: PropTypes.func,
    startTrack: PropTypes.func,
    isFree: PropTypes.bool,
    useCredit: PropTypes.number,
    freeNumCreation: PropTypes.number,
    editVideoInfo: PropTypes.object,
    curMenuIndex: PropTypes.number,
    switchCurMenuIndex: PropTypes.func,
};

export default FJVideoRemoveBgLeft;
